import { type Ref, ref } from 'vue'
import type { RingSizeInput } from '@/graphql/api'
import { useAuth } from '@/plugins/auth.ts'

interface HandleCta {
    isEnquiryModalOpen: Ref<boolean>
    closeEnquiryModal(): void
    handleAddToCart(): void
}

export function useHandleCta(
    submitExistingCustomer: () => Promise<void>,
    handleRingSizeNotSelected: () => RingSizeInput | null
): HandleCta {
    const isEnquiryModalOpen = ref(false)

    const closeEnquiryModal = () => {
        isEnquiryModalOpen.value = false
    }

    const { isLogged } = useAuth()

    const handleAddToCart = () => {
        const ringSizeInput = handleRingSizeNotSelected()
        const ringSize =
            ringSizeInput?.ringSizeId || ringSizeInput?.recommendedRingSizeId

        if (typeof ringSize !== 'string') {
            return
        }

        if (isLogged.value) {
            submitExistingCustomer()
        } else {
            isEnquiryModalOpen.value = true
        }
    }

    return {
        isEnquiryModalOpen,
        closeEnquiryModal,
        handleAddToCart,
    }
}
